/* global document */
/* global store */

import { gsap } from 'gsap';
import { InertiaPlugin } from 'Renderer/gsap/InertiaPlugin';
import { Draggable } from 'Renderer/gsap/Draggable';
import {
  controlCarousel,
} from 'Renderer/domOperations/actionOperations';
import {
  fireCarouselSlideView,
} from 'Tracking/actions/smartgroup';

gsap.registerPlugin(InertiaPlugin, Draggable);

const handleCarouselGroup = (group) => {
  const { sessionId } = store.getState();

  const scrollDirection = group.getAttribute('data-direction') || 'down';
  const looping = group.getAttribute('data-repeat') || false;
  const isVertical = ['up', 'down'].indexOf(scrollDirection) >= 0;

  const spacer = document.createElement('div');
  group.parentNode.insertBefore(spacer, group);
  spacer.style.cssText = group.style.cssText;

  group.style.overflow = 'visible';

  if (looping) {
    const contentDuplicate = group.cloneNode(true);
    contentDuplicate.style.position = 'absolute';
    const shadowAxis = isVertical ? 'y' : 'x';
    const shadowGeom = isVertical ? group.scrollHeight : group.scrollWidth;
    const tween = [];
    tween[shadowAxis] = `${shadowGeom}`;
    contentDuplicate.id = `${contentDuplicate.id}-shadow`;
    group.parentNode.appendChild(contentDuplicate);
    contentDuplicate.removeAttribute('data-behavior');
    contentDuplicate.setAttribute('data-shadow', 'true');
    const gsapProps = isVertical ? { x: 0, y: shadowGeom } : { x: shadowGeom, y: 0 };
    gsap.set(contentDuplicate.parentNode.childNodes[2], gsapProps);
  }

  group.style.position = 'absolute';
  group.setAttribute('data-active', 'true');

  if (window[`ivoCarouselEvents-${sessionId}`] == null) window[`ivoCarouselEvents-${sessionId}`] = {};
};

export const initCarouselEvents = (rootElement) => {
  const { sessionId } = store.getState();

  if (window[`ivoCarouselEvents-${sessionId}`] == null) window[`ivoCarouselEvents-${sessionId}`] = {};

  [...rootElement.querySelectorAll('div[data-behaviour=carousel]:not([data-autohide="true"])')].forEach((group) => {
    const scrollObject = group.parentNode;
    const scrollDirection = group.getAttribute('data-direction') || 'down';
    const scrollAmount = group.getAttribute('data-amount') || 0;
    const scrollDelay = parseFloat(group.getAttribute('data-delay')) || 1000;
    const looping = group.getAttribute('data-repeat') || false;

    fireCarouselSlideView(group, 0);

    if (scrollAmount > 0) {
      if (window[`ivoCarouselEvents-${sessionId}`][group.parentNode.id]) return;
      window[`ivoCarouselEvents-${sessionId}`][group.parentNode.id] = setInterval(() => {
        if (scrollObject.getAttribute('data-interacted')) clearInterval(window[`ivoCarouselEvents-${sessionId}`][group.parentNode.id]);
        if (!looping && scrollObject.hasAttribute('data-autoplay-complete')) clearInterval(window[`ivoCarouselEvents-${sessionId}`][group.parentNode.id]);
        controlCarousel(scrollObject, scrollDirection, scrollAmount);
      }, scrollDelay);
    }
  });
};

export const clearCarouselEvents = () => {
  const { sessionId } = store.getState();
  if (window[`ivoCarouselEvents-${sessionId}`] == null) return;
  Object.keys(window[`ivoCarouselEvents-${sessionId}`]).forEach((component) => {
    clearInterval(window[`ivoCarouselEvents-${sessionId}`][component]);
    delete window[`ivoCarouselEvents-${sessionId}`][component];
  });
};

const handlePannableGroup = (group) => {
  group.firstChild.style.pointerEvents = 'all';
  group.parentNode.style.pointerEvents = 'all';
  group.style.pointerEvents = 'all';

  [...group.querySelectorAll('div')].forEach(elem => elem.style.pointerEvents = 'all');

  const bounds = { maxX: 0, maxY: 0, minX: ((group.scrollWidth - group.clientWidth) * -1), minY: ((group.scrollHeight - group.clientHeight) * -1) };

  const axis = group.getAttribute('data-axis');
  let draggableAxis = 'x,y';
  if (axis === 'horizontal') draggableAxis = 'x';
  if (axis === 'vertical') draggableAxis = 'y';

  const carousel = Draggable.create(group, {
    bounds,
    edgeResistance: 1,
    type: draggableAxis,
    inertia: true,
    dragClickables: true,
    overshootTolerance: 0,
    onPress: () => {
      carousel[0].applyBounds({ maxX: 0, maxY: 0, minX: ((group.scrollWidth - group.clientWidth) * -1), minY: ((group.scrollHeight - group.clientHeight) * -1) });
    },
  });
};

const handleScrollableGroup = (group) => {
  group.style.overflow = 'scroll';
  group.style.pointerEvents = 'all';
};

export const createSmartGroupEvents = (rootElement) => {
  setTimeout(() => {
    [...rootElement.querySelectorAll('div[data-behaviour=carousel]:not([data-autohide="true"])')].forEach(elem => handleCarouselGroup(elem));
    [...rootElement.querySelectorAll('div[data-behaviour=pannable]:not([data-autohide="true"])')].forEach(elem => handlePannableGroup(elem));
    [...rootElement.querySelectorAll('div[data-behaviour=scrollable]:not([data-autohide="true"])')].forEach(elem => handleScrollableGroup(elem));
  }, 200);
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/smartGroupScript.js